import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'System|Criteria|Rules|Edit Criteria Rule|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRulesEditCriteria';
export type SPSystemCriteriaRulesEditCriteriaLocNames =
	| `${LocNameStart}TitleEdit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`;

export const spSystemCriteriaRulesEditCriteriaLocs: LocDefs<SPSystemCriteriaRulesEditCriteriaLocNames> =
	{
		SPSystemCriteriaRulesEditCriteriaTitleEdit: {
			defaultValue: 'Edit Criteria Rule',
			description: 'Edit title',
			displayPath: `${pathStart}Title`,
			displayType: 'Title',
			legacyName: 'Announcements/Tools.AnnouncementCriteria.Title.EditRule',
			...sharedProperties,
		},
		SPSystemCriteriaRulesEditCriteriaButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSystemCriteriaRulesEditCriteriaButtonSave: {
			defaultValue: 'Save',
			description: 'Save button',
			displayPath: `${pathStart}Save`,
			displayType: 'Button',
			...sharedProperties,
		},
	};

export type SPSystemCriteriaRulesEditCriteriaLocType =
	LocMap<SPSystemCriteriaRulesEditCriteriaLocNames>;
